export default __webpack_public_path__ + "static/media/emailIcon.2e40e2f5.svg";